import React from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";

const Container = styled.div<{
    enabled: boolean;
    width: number;
    height: number;
    fontSize: number;
}>`
    position: relative;
    border-radius: 50%;
    outline: none;
    font-family: urdu;
    font-weight: 500;
    font-size: ${(p) => p.fontSize}px;
    text-align: center;
    width: ${(p) => p.width}px;
    height: ${(p) => p.height}px;
    line-height: ${(p) => p.height}px;

    border: 1px solid #dcdbdc;
    color: ${(p) => (p.enabled ? "#fff" : "#000")};
    background-color: ${(p) => (p.enabled ? "#000" : "#fff")};
`;

interface SwitchProps {
    name: string;
    enabled: boolean;
    messageId: string;
    fontSize?: number;
    width?: number;
    height?: number;
    onChange: (name: string, enabled: boolean) => void;
}
interface SwitchState {
    enabled: boolean;
}
export class Switch extends React.Component<SwitchProps, SwitchState> {
    constructor(props: SwitchProps) {
        super(props);
        this.state = {
            enabled: false,
        };
    }

    onClick = () => {
        this.setState({ enabled: !this.state.enabled }, () => {
            this.props.onChange(this.props.name, this.state.enabled);
        });
    };

    render() {
        const { enabled, messageId, fontSize, width, height } = this.props;

        return (
            <Container
                enabled={enabled}
                fontSize={fontSize || 16}
                width={width || 75}
                height={height || 75}
                onClick={this.onClick}
            >
                <FormattedMessage id={messageId} />
            </Container>
        );
    }
}
